'use client'

import {usePathname, useSearchParams} from 'next/navigation'
import Script from 'next/script'
import {Suspense, useEffect} from 'react'

const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? ''

declare global {
   interface Window {
      dataLayer: unknown[]
      gtag: (...arguments_: unknown[]) => void
   }
}

const sendPageView = (
   pagePath: string,
   pageLocation: string,
   pageTitle: string
) => {
   if (!measurementId || typeof window === 'undefined') {
      return
   }
   if (typeof window.gtag !== 'function') {
      return
   }

   window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_location: pageLocation,
      page_title: pageTitle
   })
}

const GoogleAnalyticsRouteListener = () => {
   const pathname = usePathname()
   const searchParameters = useSearchParams()
   const searchParametersString = searchParameters.toString()
   const pagePath =
      searchParametersString.length > 0
         ? `${pathname}?${searchParametersString}`
         : pathname

   useEffect(() => {
      const origin = window.location.origin
      const pageLocation = `${origin}${pagePath.startsWith('/') ? pagePath : `/${pagePath}`}`
      sendPageView(pagePath, pageLocation, document.title)
   }, [pagePath])

   return null
}

export const GoogleAnalytics = () => {
   if (!measurementId) {
      return null
   }

   return (
      <>
         <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
            strategy={'afterInteractive'}
         />
         <Script
            id={'ga4-config'}
            strategy={'afterInteractive'}
         >
            {`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${measurementId}', { send_page_view: false });
`}
         </Script>
         <Suspense fallback={null}>
            <GoogleAnalyticsRouteListener />
         </Suspense>
      </>
   )
}
